export default __webpack_public_path__ + "static/media/sportive-car.6e3066fa.png";